/* (c) Copyright Frontify Ltd., all rights reserved. */

export const LINK_PLUGIN = 'link-plugin';
